import { render, staticRenderFns } from "./CloseSmall.vue?vue&type=template&id=e32bf6b6"
import script from "./CloseSmall.vue?vue&type=script&lang=js"
export * from "./CloseSmall.vue?vue&type=script&lang=js"
import style0 from "./CloseSmall.vue?vue&type=style&index=0&id=e32bf6b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports